import { useFetchContentQuery } from "@marketing-site/api/urbana/contentful/apiSlice";
import { PageQuery } from "@marketing-site/api/urbana/contentful/queries";
import { StarRatings } from "@marketing-site/components";
import { SEO } from "@marketing-site/components/_contentful";
import {
  HeroDownload,
  IHeroDownloadAlias,
} from "@marketing-site/components/_contentful/hero/HeroDownload";
import { NavigationBar } from "@marketing-site/components/navbar/NavigationBar";
import { theme } from "@marketing-site/styles";
import { mapComponents } from "@marketing-site/utils";
import React, { Fragment } from "react";
import { useLocation, useParams } from "react-router-dom-v5-compat";
import styled from "styled-components";
import { LoadingPage } from "../Page/LoadingPage";
import Footer from "@whopper/footer";


export type IDownloadProps = {
  locale?: string;
};

export const Download = () => {
  const pageData: IDownloadProps = useParams();
  const location = useLocation();
  const locale = pageData.locale || "en";
  const path = location.pathname;
  const slug = "download";

  const {
    data: contentfulData,
    error: _contentfulError,
    isLoading: contentfulLoading,
  } = useFetchContentQuery({
    query: PageQuery(slug, locale),
    space: "hopperCom",
  });

  const getBody = () => {
    if (contentfulLoading || !contentfulData) {
      return <LoadingPage />;
    } else {
      const page = contentfulData;
      const children = page.contentCollection.items;

      const scanToDownloadText = children.find(
        ({ title }: { title: string }) => title === "Scan To Download Text"
      ).shortText;

      const claimYourSavingsText = children.find(
        ({ title }: { title: string }) => title === "Claim Your Savings Text"
      ).shortText;

      const downloadPageMap = {
        HeroProduct: (props: React.PropsWithChildren<IHeroDownloadAlias>) => {
          return (
            <HeroDownload
              {...props}
              scanToDownloadText={scanToDownloadText}
              getTheAppText={claimYourSavingsText}
            >
              <StarRatings
                label={
                  children.find(
                    ({ title }: { title: string }) =>
                      title === "Star Ratings Text"
                  ).richText.json
                }
              />
            </HeroDownload>
          );
        },
      };

      const childComponents = mapComponents(children, slug, downloadPageMap);

      return (
        <>
          <SEO {...page.seo} locale={locale} canonical={path} />
          <NavigationBar contentfulNavProps={page.navigation} />
          <BackgroundWrapper>
            {childComponents.map((component, i) => {
              return <Fragment key={i}>{component}</Fragment>;
            })}
          </BackgroundWrapper>
          <Footer {...page.navigation.footer} />
        </>
      );
    }
  };

  return <React.Fragment>{getBody()}</React.Fragment>;
};

const BackgroundWrapper = styled.div`
  background-color: ${theme.colors.grey[100]};
  height: 100vh;
`;
